export const getElComputedStyle = (el: Element, property: string) =>
  window ? window.getComputedStyle(el).getPropertyValue(property) : undefined;

export const convertPixelsToRem = (pixel: number) => {
  const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return pixel / fontSize;
};
